export default __webpack_public_path__ + "static/media/FaceBook.2ef18188.svg";